import React, { useState } from "react";
import { useAlert, useApi } from "@/";
import { Button, InputField } from "@/components";
import { useNavigate } from "react-router";
const RecoverPassword = ({ setAlertOpen = false, data = {} }) => {
  const { alert, AlertDialog } = useAlert();
  const { callApi, loading } = useApi();
  const [email, setEmail] = useState("");
  const handleChange = (field, value) => {
    setEmail(value);
  };

  const [error, setError] = useState("");
  const handleRecoverPassword = async () => {
    try {
      if (!email) {
        setError("Please enter your email address");
        return;
      }
      const response = await callApi("/common/forgot-password", "POST", {
        email: email,
      });
      if (response.success) {
        await alert(
          "Password recovery email sent successfully. Please note that it may take 10-15 minutes to receive the email."
        );
        setAlertOpen(false);
      } else if (response.error) {
        setError(response.error);
        await alert(response.error);
        setAlertOpen(false);
      }
    } catch (error) {
      const errorMessage = error.message || "An unexpected error occurred";
      setError(errorMessage);
      await alert(errorMessage);
      setAlertOpen(false);
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <InputField
        label="Email Address"
        type="email"
        placeholder="Enter the registered email"
        value={email}
        onChange={(value) => handleChange("email", value)}
        disabled={loading}
      />

      <div className="w-full">
        <Button
          className="h-12 w-full mt-4"
          size="md"
          onClick={handleRecoverPassword}
          isLoading={loading}
          loadingText="Sending..."
        >
          Send
        </Button>
      </div>
      <AlertDialog />
    </div>
  );
};

export default RecoverPassword;
